export default {
  title: 'Vielen Dank für die Übermittlung deiner Daten, um Zahlungen zu erhalten.',
  description:
    'Die Überprüfung durch Stripe kann bis zu 48 Stunden dauern. In der Zwischenzeit kannst du mit den nächsten Schritten fortfahren. Wir werden dich per E-Mail informieren, sobald deine Angaben bestätigt sind.',
};
